module.exports = __webpack_public_path__ + "img/logo-en-left-blue.4b9ddc3.svg";